var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c(_vm.layoutName,{tag:"component"},[_c('router-view'),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"loader-wrapper"},[_c('div',{staticClass:"loader"},[_vm._v("Loading...")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }